module.exports = ".document-url{display:flex;align-items:center}\n"